<td class="userManagement__siteCell userManagementTableSite__cell siteCell--short">
  <div class="siteCell__wrapper">
    <button
      type="button"
      (click)="emitNavigateToSite()"
      class="siteCell__name"
      aria-label="Navigate to site"
      ppTooltip
      [ppTrimTooltip]="true"
      [ppTitle]="siteName"
    >
      {{ siteName }}
    </button>
  </div>
</td>
